import React from 'react';
import { css } from '@emotion/core';
import { preventMarginCollapse } from 'styles/common';
import Notification from 'client/components/JoinGame/Notification';
import ContainerMaskFlowInfoAndAction from 'client/components/infoDialog/ContainerMaskFlowInfoAndAction';

export default function JoinWrapper({ children }) {
    return (
        <div css={[css(preventMarginCollapse), borderStyle]}>
            <ContainerMaskFlowInfoAndAction />
            <Notification />
            {children}
        </div>
    );
}

const borderStyle = css`
    position: relative;
`;
